<template>
    <div class="component">
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title mt-1" v-if="this.role == 'admin'">
                                        {{ !company.id ? 'Nova' : 'Editar' }} Unidade</h5>
                                    <h5 class="card-title mt-1" v-if="this.role != 'admin'"> {{ 'Visualizar' }}
                                        Unidade</h5>
                                </div>
                                <div class="col-6"></div>
                            </div>
                            <hr/>
                            <div class="form-group">
                                <label for="name">
                                    Empresa
                                    <span v-if="required('corporate_group_id')">*</span>
                                </label>
                                <select
                                        v-model="company.corporate_group_id"
                                        id
                                        class="form-control"
                                        v-bind:class="{'input-error': showError('corporate_group_id')}"
                                        v-bind:disabled="this.role != 'admin'"
                                >
                                    <option
                                            v-for="group in groups"
                                            v-bind:key="group.id"
                                            :value="group.id"
                                    >{{ group.name }}
                                    </option>
                                </select>
                                <div
                                        class="general-error"
                                        v-if="showError('corporate_group_id')"
                                >O campo Empresa é necessário
                                </div>
                            </div>
                            <div class="form-group form-group--error">
                                <label for="name">
                                    Nome
                                    <span v-if="required('corporate_name')">*</span>
                                </label>
                                <input
                                        v-model="company.corporate_name"
                                        name="name"
                                        type="text"
                                        class="form-control"
                                        v-bind:class="{'input-error': showError('corporate_name')}"
                                        v-bind:disabled="this.role != 'admin'"
                                />
                                <div
                                        class="general-error"
                                        v-if="showError('corporate_name')"
                                >O campo Nome é necessário
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="business_type_field">
                                    Tipo de Negócio
                                </label>
                                <input
                                  id="business_type_field"
                                  v-model="company.business_type"
                                  name="business_type"
                                  type="text"
                                  class="form-control"
                                  placeholder="Digite o tipo de negócio"
                                  v-bind:disabled="this.role != 'admin'"
                                  @input="console.log('business_type changed:', company.business_type)"
                                />
                            </div>
                            <div class="form-group">
                                <label for="name">
                                    CNPJ
                                    <span v-if="required('cnpj')">*</span>
                                </label>
                                <input
                                        v-model="company.cnpj"
                                        v-mask="'##.###.###/####-##'"
                                        type="text"
                                        class="form-control"
                                        v-bind:class="{'input-error': showError('cnpj')}"
                                        v-bind:disabled="this.role != 'admin'"
                                />
                                <div class="general-error" v-if="showError('cnpj')">O campo CNPJ é necessário</div>
                            </div>
                            <div class="form-group">
                                <label for="name">
                                    Telefone
                                    <span v-if="required('phone')">*</span>
                                </label>
                                <input
                                        v-model="company.phone"
                                        v-mask="'(##) ####-####'"
                                        type="text"
                                        class="form-control"
                                        v-bind:class="{'input-error': showError('phone')}"
                                        v-bind:disabled="this.role != 'admin'"
                                />
                                <div class="general-error" v-if="showError('phone')">O campo Telefone é necessário</div>
                            </div>

                            <div class="form-group">
                                <label for="name" v-if="!company.id">Logo:</label>
                                <label for="name" v-if="company.id">Alterar Logo:</label>

                                <b-form-file
                                        v-model="company.photo_id"
                                        placeholder="Escolha um arquivo"
                                        drop-placeholder="Arraste o arquivo aqui..."
                                        browse-text="Procurar"
                                        accept="image/jpeg, image/png, image/jpg"
                                        v-on:change="uploadImage"
                                        v-bind:disabled="this.role != 'admin'"
                                ></b-form-file>
                            </div>
                            <div
                                    class="logoContent w-100"
                                    v-if="tempImage || (company.photo && company.photo.url)"
                            >
                                <div class="d-flex justify-content-center align-items-center w-100">
                                    <img
                                            :src="tempImage ? tempImage : company.photo.url"
                                            style="width: 25%; margin-bottom:18px"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="name">
                                    Site
                                    <span v-if="required('site')">*</span>
                                </label>
                                <input
                                        v-model="company.site"
                                        type="text"
                                        class="form-control"
                                        v-bind:class="{'input-error': showError('site')}"
                                        v-bind:disabled="this.role != 'admin'"

                                />
                                <div class="general-error" v-if="showError('site')">O campo Site é necessário</div>
                            </div>

                            <div class="form-group">
                                <label for="name">
                                    Responsável técnico
                                    <span v-if="required('technical_responsible')">*</span>
                                </label>
                                <div
                                        class="general-error"
                                        v-if="showError('technical_responsible')"
                                >O campo Responsável técnico é necessário
                                </div>
                                <button style="margin-bottom: 15px;" type="button" class="btn btn-primary" v-on:click="addTechnicalResponsible">
                                    <span>Responsável técnico <font-awesome-icon icon="plus" /> </span>
                                </button>
                                  <Accordion v-for="(responsible, index) in technicalResponsibles"
                                  :key="index">
                                    <template v-slot:title>
                                      <div class="row">
                                        <div class="col-2" @click="removeTechnicalResponsible(index)">
                                          <font-awesome-icon icon="trash" class="ml-1" />
                                        </div>
                                        <div class="col-10">
                                          <span class="label">Responsável Técnico {{ index + 1 }}</span>
                                        </div>
                                      </div>
                                    </template>
                                    <template v-slot:body>
                                      <br />
                                      <div class="card-content">
                                        <div class="row">
                                          <div class="col-6">
                                            <div class="form-group">
                                              <label class="textGray">Nome do Responsável Técnico</label>
                                              <input
                                                type="text"
                                                class="form-control"
                                                required 
                                                v-model="responsible.name"
                                              />
                                            </div>
                                            <div class="form-group">
                                              <label class="textGray">Função do Responsável Técnico</label>
                                              <textarea
                                                class="form-control"
                                                name="type"
                                                required
                                                v-model="responsible.function"
                                              ></textarea>
                                              <br/>
                                              <!-- Campo CREA removido: apontamento passado pelo
                                                   Marlon em 14/08/2026. O CREA vai no campo Funcao
                                                   acima, que ja alimenta a assinatura e a tabela do
                                                   documento. O valor antigo segue no banco e no
                                                   payload, so nao ha mais onde edita-lo nem onde
                                                   ele seja impresso. -->
                                              <div class="form-group">
                                                <label class="textGray">Assinatura do Responsável Técnico</label>
                                                  <b-form-file
                                                          required
                                                          v-model="responsible.signature"
                                                          placeholder="Escolha um arquivo"
                                                          drop-placeholder="Arraste o arquivo aqui..."
                                                          browse-text="Procurar"
                                                          accept="image/jpeg, image/png, image/jpg"
                                                          v-on:change="event => uploadImageSignature(index, event)"
                                                  />
                                              </div>
                                              <div
                                                  class="logoContent w-100"
                                                  v-if="responsible.signature">
                                                    <div class="d-flex justify-content-center align-items-center w-100">
                                                        <img :src="responsible.signature"
                                                                style="width: 25%; margin-bottom:18px"/>
                                                    </div>
                                                </div>
                                            </div>
                                          </div>
                                        </div>
                                        <br />
                                      </div>
                                    </template>
                                  </Accordion>
                            </div>

                            <Address :data="address" ref="addressComponent" :submited="submited"></Address>
                            <div class="form-group">
                                <b-form-group label="A unidade possui os campos adicionais no relatório de APR?"
                                              v-bind:disabled="this.role != 'admin'">
                                    <b-form-radio v-model="company.extra_fields_apr" name="some-radios" value="1">Sim
                                    </b-form-radio>
                                    <b-form-radio v-model="company.extra_fields_apr" name="some-radios" value="0">Não
                                    </b-form-radio>
                                </b-form-group>
                            </div>
                            <div class="form-group">
                                <div>
                                    <br/>
                                    <b-alert
                                            v-show="success"
                                            variant="success"
                                            show
                                    >Unidade {{ !company.id ? 'Criada' : 'Salva' }}
                                    </b-alert>

                                    <b-alert v-show="warning" variant="warning" show>Ocorreu um erro
                                      <div v-for="warning in error" :key="warning">
                                        <ul>
                                          <li>
                                            {{ warning.join(', ') }}
                                          </li>
                                        </ul>
                                      </div>
                                    </b-alert>
                                    <b-alert v-show="addressError" variant="danger" show>Adicione o endereço</b-alert>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6"></div>
                                <div class="col-6" v-if="this.role =='admin'">
                                    <button
                                            type="button"
                                            v-on:click="save()"
                                            class="btn btn-success float-right"
                                    ><span>Salvar  <font-awesome-icon icon="save" /> </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Address from "@/components/AddressFields.vue";
import axios from "@/api/axios";
import {required} from "vuelidate/lib/validators";
import Accordion from "@/components/Accordion.vue";

export default {
  name: "NewCompany",
  props: {
    id: String
  },
  components: {
    Address,
    Accordion,
  },

  data() {
    return {
      technicalResponsibles: [],
      company: {},
      address: {},
      groups: [],
      success: false,
      error: [],
      warning: false,
      submited: false,
      uniqueValue: false,
      addressError: false,
      role: localStorage.getItem("auth.role"),
      tempImage: "",
      items: [
        {
          text: "Unidades",
          href: "#/admin/Companies/ListCompanies"
        },
        {
          text: "Nova",
          active: true
        }
      ],

      professionalSelected: null,
      professionals: [
        {text: 'Responsável técnico 1', value: '1'},
        {text: 'Responsável técnico 2', value: '2'},
        {text: 'Ambos', value: '3'},
      ],

      showFieldsProfessional1: false,
      showFieldsProfessional2: false,
      tempImageSignature1: "",
      tempImageSignature2: "",
    };
  },
  validations: {
    company: {
      corporate_name: {
        required
      },
      cnpj: {
        required
      },
      phone: {
        required
      },
      site: {
        required
      },
      crea: {},
      corporate_group_id: {
        required
      },
      technical_responsible: {}
    }
  },
  mounted() {
    if (this.id) {
      this.getCompany();
    } else {
      this.company.extra_fields_apr = '';
      this.company.business_type = '';
    }
    this.getGroups();
    this.addTechnicalResponsible();
    this.getUserType();
  },
  methods: {
    addTechnicalResponsible: function () {
      this.technicalResponsibles.push({
        id: null,
        name: "",
        function: "",
        crea: "",
        signature: ""
      });
    },
    removeTechnicalResponsible: function (index) {

      this.technicalResponsibles.splice(index, 1);
      let formData = new FormData();
      formData.append("_method", 'PUT');
      this.technicalResponsibles.forEach((responsible, index) => {
        formData.append(`technicalResponsibles[${index}][id]`, responsible.id);
        formData.append(`technicalResponsibles[${index}][name]`, responsible.name);
        formData.append(`technicalResponsibles[${index}][function]`, responsible.function);
        formData.append(`technicalResponsibles[${index}][crea]`, responsible.crea || "");
        formData.append(`technicalResponsibles[${index}][signature]`, responsible.signature);
      });
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/${this.id}`,formData
        )
        .then(response => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 1500);
          return response.data;
        })
        .catch(error => {
              if (error.response.status === 422) {
                this.warning = true;
                this.error = error.response.data.errors;
              }
        });
    },
    getGroups: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/corporate-groups?page[number]=1&page[size]=100`,
          {}
        )
        .then(response => {
          this.groups = response.data.data;
        });
    },
    getCompany: function () {
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/${this.id}?include=corporate-group,address,technicals`
        )
        .then(response => {
          this.company = response.data.data;
          console.log('Company data loaded:', this.company);

          // Garantir que business_type seja inicializado
          if (!this.company.business_type) {
            this.company.business_type = '';
          }

          this.address = this.company.address;

          this.company.extra_fields_apr = this.company.extra_fields_apr == true ? 1 : (this.company.extra_fields_apr == false ? 0 : this.company.extra_fields_apr);
          this.$refs["addressComponent"].address = this.address;
          this.technicalResponsibles = this.company.technicals.map(responsible => {
            return {
              id: responsible.id,
              name: responsible.technical_responsible_name,
              function: responsible.technical_responsible_function,
              crea: responsible.technical_responsible_crea,
              signature: responsible.signature.url
            };
          });
          if (this.technicalResponsibles.length == 0) {
              this.addTechnicalResponsible();
          }
        });
    },
    AddressError: function () {
      this.addressError = false;
      if (this.address.postal_code == "") {
        this.addressError = true;
      }
    },
    isAddressValid: function () {
      const addressComponent = this.$refs.addressComponent;
      if (!addressComponent) {
        return true;
      }
      addressComponent.$v.$touch();
      return !addressComponent.$v.$invalid;
    },
    save: function () {
      if (this.company.id) {
        return this.edit();
      }
      this.submited = true;
      if (!this.$v.$invalid) {
        if (this.isAddressValid()) {
          let formData = new FormData();

          // Anexe cada campo manualmente
          formData.append("corporate_name", this.company.corporate_name);
          formData.append("business_type", this.company.business_type || "");
          formData.append("cnpj", this.company.cnpj);
          formData.append("phone", this.company.phone);
          formData.append("site", this.company.site);
          formData.append("crea", this.company.crea);
          formData.append("corporate_group_id", this.company.corporate_group_id);
          formData.append("address", JSON.stringify(this.address));
          formData.append("image", this.tempImage);
          formData.append("extra_fields_apr", this.company.extra_fields_apr);

          // Anexe cada responsável técnico
          this.technicalResponsibles.forEach((responsible, index) => {
            formData.append(`technicalResponsibles[${index}][name]`, responsible.name);
            formData.append(`technicalResponsibles[${index}][function]`, responsible.function);
            formData.append(`technicalResponsibles[${index}][crea]`, responsible.crea || "");
            formData.append(`technicalResponsibles[${index}][signature]`, responsible.signature);
          });

          // Use formData em vez do objeto company
          axios
            .post(`${process.env.VUE_APP_API_HOST}/api/admin/companies`, formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(response => {
              console.log('response', response)
              this.success = true;
              setTimeout(() => {
                this.success = false;
                this.$router.push("ListCompanies");
              }, 1500);
              return response.data;
            })
            .catch(error => {
              if (error.response.status === 422) {
                this.warning = true;
                this.error = error.response.data.errors;
              }
            });
        } else {
          this.AddressError();
        }
      }
    },
    edit: function () {
      this.submited = true;
      if (!this.isAddressValid()) {
        this.AddressError();
        return;
      }
      console.log('editando...');
      let formData = new FormData();

      // Anexe cada campo manualmente
      formData.append("corporate_name", this.company.corporate_name);
      formData.append("business_type", this.company.business_type || "");
      formData.append("cnpj", this.company.cnpj);
      formData.append("phone", this.company.phone);
      formData.append("site", this.company.site);
      formData.append("crea", this.company.crea);
      formData.append("corporate_group_id", this.company.corporate_group_id);
      formData.append("address", JSON.stringify(this.address));
      formData.append("image", this.tempImage);
      formData.append("extra_fields_apr", this.company.extra_fields_apr);
      formData.append("_method", 'PUT');

      // Anexe cada responsável técnico
      this.technicalResponsibles.forEach((responsible, index) => {
        formData.append(`technicalResponsibles[${index}][id]`, responsible.id);
        formData.append(`technicalResponsibles[${index}][name]`, responsible.name);
        formData.append(`technicalResponsibles[${index}][function]`, responsible.function);
        formData.append(`technicalResponsibles[${index}][crea]`, responsible.crea || "");
        formData.append(`technicalResponsibles[${index}][signature]`, responsible.signature);
      });
      axios
        .post(
          `${process.env.VUE_APP_API_HOST}/api/admin/companies/` +
          this.company.id,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
            this.$router.push("ListCompanies");
          }, 1500);
          return response.data;
        })
        .catch(error => {
              if (error.response.status === 422) {
                this.warning = true;
                this.error = error.response.data.errors;
              }
        });
    },
    showError: function (attribute) {
      return this.$v.company[attribute].$invalid && this.submited;
    },
    required: function (attribute) {
      return this.$v.company[attribute].$params.required;
    },
    getUserType: function () {
      if (this.role == "client" || this.role == "employee") {
        if (this.id == undefined) {
          this.$router.push("/admin/Home");
        }
      }
    },
    uploadImage: function (e) {
      const file = e.target.files[0];

      if (!file.type.includes("image/")) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = event => {
          this.tempImage = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    uploadImageSignature: function (index, event) {
      const file = event.target.files[0];

      if (!file || !file.type.includes("image/")) {
        return;
      }

      // Converter o arquivo em uma URL de dados (base64)
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          // Atualizar a URL da imagem para a assinatura
          this.technicalResponsibles[index].signature = event.target.result;
        };

        reader.readAsDataURL(file);
      }
    },
  }
};
</script>

<style lang="scss">
@import "../../../styles/General.scss";

.bv-no-focus-ring {
  outline: none !important;
}

.accordion .header {
  background-color: #d9d9d9;
  border: 0.5px solid #d9d9d9;
}
</style>
